// routing
import Routes from "routes";

// project imports
import Locales from "ui-component/Locales";
import NavigationScroll from "layout/NavigationScroll";
import RTLLayout from "ui-component/RTLLayout";
import Snackbar from "ui-component/extended/Snackbar";
import ThemeCustomization from "themes";

// auth provider
// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
import { JWTProvider as AuthProvider } from "contexts/JWTContext";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';

// axios.defaults.baseURL = 'https://dpsapi.alumni.live/api';
// axios.defaults.baseURL = "http://192.168.68.133:5001/api";
// axios.defaults.baseURL = 'https://ssvmapi.alumni.live/api';
axios.defaults.baseURL = 'https://api.alumni.live/api';

// axios.defaults.baseURL = 'https://msdapi.alumni.live/api';
// axios.defaults.baseURL = 'http://192.168.68.158:5001/api'
// ==============================|| APP ||============================== //


const App = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const { pathname, search } = location;
    const currentUrl = `${window.location.origin}${pathname}${search}`;

    localStorage.setItem('currentUrl', currentUrl);
    if (pathname === "/") {
      navigate("/login");
    }
  }, [location, navigate]);
  return (
    <ThemeCustomization>
      <RTLLayout>
        <Locales>
          <NavigationScroll>
            <AuthProvider>
              <>
                <Routes />
                <Snackbar />
              </>
            </AuthProvider>
          </NavigationScroll>
        </Locales>
      </RTLLayout>
    </ThemeCustomization>
  );
};

export default App;
